import { graphql } from '@/client/services/api/graphql/gql';

export const badgeAwardsQuery = graphql(`
  query BadgeAwards(
    $user: IDQueryOperatorArgs
    $page: Int! = 0
    $pageSize: Int! = 50
    $includeTotalCount: Boolean! = true
  ) {
    badgeAwards(
      user: $user
      page: $page
      pageSize: $pageSize
      includeTotalCount: $includeTotalCount
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        totalCount
      }
      edges {
        node {
          acquiredDate
          badge
          badgeDetails {
            title
            uploadedImage
          }
        }
      }
    }
  }
`);
